import { render, staticRenderFns } from "./CobrancaOperacao.vue?vue&type=template&id=f90b6718"
import script from "./CobrancaOperacao.vue?vue&type=script&lang=js"
export * from "./CobrancaOperacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports